/**
 * {
 *  "appId":"1187297398532108290",
 *  "code":"application",
 *  "hiddenFlag":"N",
 *  "icon":"icon-app",
 *  "id":"1184049793396121602",
 *  "levels":1,
 *  "linkedList":[],
 *  "menuTips":"",
 *  "name":"\u5E94\u7528\u914D\u7F6E\u4E2D\u5FC3",
 *  "nodeId":"1184049793396121602",
 *  "nodeParentId":"-1",
 *  "num":14.00,
 *  "parentId":"-1",
 *  "url":"Layout"
 * }
 */
export default class CbdMenu {
  constructor() {
    this.appId = null;
    this.code = null;
    this.hiddenFlag = null;
    this.icon = null;
    this.id = null;
    this.levels = null;
    this.linkedList = [];
    this.menuTips = null;
    this.name = null;
    this.nodeId = null;
    this.nodeParentId = null;
    this.num = null;
    this.parentId = null;
    this.url = null;
    this.children = [];
  }
}
